<template>
    <div>

        <div class="component-order" v-for="order in orders">
          <figure class="component-order-image">
            <img :src="$iconFolder + 'cart.svg'"/>
          </figure>
          <div class="component-order-content">
            <h2>Commande n°<span>{{ order.invoice.reference }}</span></h2>

            <ul class="component-order-resume">
              <li class="component-order-items-item">
                <img class="icon" :src="$iconFolder + 'calendar.svg'"/>
                <div>
                  <strong>Date de facturation</strong>
                  <p>{{ order.invoice.invoiced_at }}</p>
                </div>
              </li>
              <li class="component-order-items-item">
                <img class="icon" :src="$iconFolder + 'invoice.svg'"/>
                <div>
                  <strong>Montant</strong>
                  <p>{{ order.currency }} {{ order.amount_total|formatNumber }}</p>
                </div>
              </li>
              <li class="component-order-items-item">
                <img class="icon" :src="$iconFolder + 'money.svg'"/>
                <div>
                  <strong>Statut de paiement</strong>
                  <p>{{ order.invoice.payment_status }}</p>
                </div>
              </li>
            </ul>

            <ul class="component-order-items">
              <li v-for="item in order.products" class="component-order-items-item" v-if="item.parent_id == null">
                <h3>{{ item.quantity }} x {{ item.name }}</h3>
                <div v-for="schedule in item.schedule_details" class="component-order-items-item">
                  <div  v-if="schedule && schedule.schedule_start_at">
                    <schedule :start-at="schedule.schedule_start_at" :end-at="schedule.schedule_end_at"></schedule>
                    - {{ schedule.user ? schedule.user.name : '' }}
                  </div>
                  <span v-else> - Créneau libre</span>
                </div>
              </li>
            </ul>

            <footer>
              <a :href="order.invoice.download_link" target="_blank" class="bt bt-create"><span>Télécharger la facture</span></a>
            </footer>

          </div>
        </div>

    </div>
</template>
<script>
    import OrderService from './OrderService.js';
    export default {
        name: 'Widget',
        props: ['person_id'],
        data () {
            return {
                orders: null
            }
        },
        mounted: function(){

            OrderService.getOrderByCustomer(this.person_id).then((response) => {
                console.log('ORDER HISTORIQUE', response.data);
                this.orders = response.data;
            }).catch((response) => {
                console.log("error", response);
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/order/OrderByPersonWidget.vue